exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .ag-floating-bottom .ag-row-hover .renderer-pinned-container {\r\n    background-color: #CCCCCC;\r\n}\r\n.renderer-pinned-container {\r\n    font-size: 13px;\r\n    background-color: #959595;\r\n}\r\n.renderer-pinned-default {\r\n    text-overflow: ellipsis;\r\n    display: block;\r\n    overflow: hidden;\r\n}\r\n.lfwms-checkbox {\r\n    font-size: 15px;\r\n    color: #FFFFFF;\r\n    padding-left: 2px;\r\n    padding-top: 7px;\r\n}\r\n::ng-deep .ag-floating-bottom .ag-row-hover .lfwms-checkbox {\r\n    color: #959595;\r\n}\r\n.fa-disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;    \r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/common/view-balances-popup/view-balances-cell-renderer/view-balances-cell-renderer.component.css
// module id = ../../../../../src/app/shared/components/common/view-balances-popup/view-balances-cell-renderer/view-balances-cell-renderer.component.css
// module chunks = main